// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  display: grid;
  grid-template-columns: 15% 85%;
  height: 100vh;
  position: relative;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/page/dashboard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AACF","sourcesContent":[".dashboard-container{\n  display: grid;\n  grid-template-columns: 15% 85%;\n  height: 100vh;\n  position: relative;\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
